import {
  AssistantFeedback,
  AssistantSearch,
} from '@vi-iot/client/apis/assistant/assistant.api-model';

export const assistantSearchMockedData: AssistantSearch[] = [
  // vitocall
  {
    title:
      'Recall: <hit>Vitocal</hit> 15x-/25x-A (H) Compressor line replacement and software update (quality release fall 2022)',
    body:
      'Recall: <hit>Vitocal</hit> 15x-/25x-A (H) Compressor line replacement and software ... )\n\nIn the case of <hit>Vitocal</hit> 15x-/25x-A (outdoor unit) appliances ... ',
    documentType: {
      value: 'CustomDocumentType1',
      label: ['Q-In-Goodwill / Recall'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/49c08cf0-d6c7-41fd-843f-5f7099eb9490.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2024-03-26',
      label: ['03/26/2024'],
    },
    id: 'en-so-49c08cf0-d6c7-41fd-843f-5f7099eb9490',
    objectId: 'esc/en-so-49c08cf0-d6c7-41fd-843f-5f7099eb9490',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 16189,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: [
      'Q-In-Goodwill / Recall',
      'Vitocal 250-AH, Vitocal 150-A, Vitocal 250-A',
      '03/26/2024',
    ],
    informationType: {
      value: ['Q-In-Goodwill_Recall'],
      label: ['Q-In-Goodwill / Recall'],
    },
  },
  {
    title: '<hit>Vitocal</hit> 100-A_disinfection faulty',
    body:
      '<hit>Vitocal</hit> 100-A_disinfection faulty\n\n    \n      Symptom\n\n      \t"Disinfection" shown on the display, disinfection programme not successful\n\n\n\n\n\n    \n    \n      Cause\n\n      \t#\tCause description\n\t#1\tCompatibility problem ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/5aee517d-d89e-4695-a5ea-e614f0d22179.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2024-02-02',
      label: ['02/02/2024'],
    },
    id: 'en-so-5aee517d-d89e-4695-a5ea-e614f0d22179',
    objectId: 'esc/en-so-5aee517d-d89e-4695-a5ea-e614f0d22179',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 10080,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Error description', 'Heat Pumps, Vitocal 100-A', '02/02/2024'],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: '<hit>Vitocal</hit> 100-A_CONN error',
    body:
      '<hit>Vitocal</hit> 100-A_CONN error\n\n    \n      Symptom\n\n      \tConn" shown on the display, connection to the control panel interrupted\n\n\n\n\n\n    \n    \n      Cause\n\n      \t#\tCause description\n\t#1 ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/aad1de5d-996e-48ed-baca-a37bf647422b.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2024-02-02',
      label: ['02/02/2024'],
    },
    id: 'en-so-aad1de5d-996e-48ed-baca-a37bf647422b',
    objectId: 'esc/en-so-aad1de5d-996e-48ed-baca-a37bf647422b',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 10071,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Error description', 'Heat Pumps, Vitocal 100-A', '02/02/2024'],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: '<hit>Vitocal</hit> 060-A_Error ER2',
    body:
      '<hit>Vitocal</hit> 060-A_Error ER2\n\n    \n      Symptom\n\n      Behavior of the installation\n\nSymptom\n\n\tThe error message ER2 cannot be quitted. This occurs sporadically, recurrently. ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/d80d4192-03cc-4ea9-918d-50e8499ab5f0.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2023-09-29',
      label: ['09/29/2023'],
    },
    id: 'en-so-d80d4192-03cc-4ea9-918d-50e8499ab5f0',
    objectId: 'esc/en-so-d80d4192-03cc-4ea9-918d-50e8499ab5f0',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 9920,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Error description', 'Vitocal 060-A', '09/29/2023'],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: '<hit>Vitocal</hit> 25x-A_Enable fan ring heater',
    body:
      '<hit>Vitocal</hit> 25x-A_Enable fan ring heater\n\n    \n      Symptom\n\n      \tIn extreme weather conditions, <hit>Vitocal</hit> 25x-A systems may experience ice formation and defrosting problems. ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/ecf2112b-68c4-4231-a6fd-19c8dc341d7b.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2024-02-05',
      label: ['02/05/2024'],
    },
    id: 'en-so-ecf2112b-68c4-4231-a6fd-19c8dc341d7b',
    objectId: 'esc/en-so-ecf2112b-68c4-4231-a6fd-19c8dc341d7b',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 13313,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Error description', 'Heat Pumps', '02/05/2024'],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: 'E3 One Base <hit>Vitocal_Bundle-Update_Software-Version</hit> 2214',
    body: 'E3 One Base <hit>Vitocal_Bundle-Update_Software-Version</hit> 2214',
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1648212911465/viessmann/confluence/TIP/E3-One-Base-Vitocal_Bundle-Update_Software-Version-2214-~-E3-One-Base-Vitocal_Bundle-Update_Software-Version-2214_80578873_EN.html',
    downloadDenied: false,
    category: {
      value: 'TD-TIPs',
      label: ['TD-TIPs'],
    },
    modificationDate: {
      value: '2022-11-21',
      label: ['11/21/2022'],
    },
    id: 'iu-309-2bc42f09-516b-47c4-b8c1-653273df5c66',
    objectId: 'esc/iu-309-2bc42f09-516b-47c4-b8c1-653273df5c66',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 1975,
    visibilityLevel: {
      level: 1,
      label: 'Internal',
      color: '#FF3E17',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['TD-TIPs', '11/21/2022'],
    informationType: {
      value: ['Solution database\u001fTD-TIPs'],
      label: ['TD-TIPs'],
    },
  },

  // Vitocall 200-S
  {
    title: 'E3 One <hit>Base_Vitocal</hit> Function Deep Dive',
    body:
      'E3 One <hit>Base_Vitocal</hit> Function Deep Dive\n                \n\n            \n\n        \n\n        \n            \n                \tSolution\n\tDevice Number(s) [ ... , 7938765, 7938766, 7959723, 7938763 \t<hit>Vitocal</hit> 250-A  ODU\tAWO-AC 251.A13 ... ',
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1648212911465/viessmann/confluence/TIP/E3-One-Base_Vitocal-Function-Deep-Dive_80577515_EN.html',
    downloadDenied: false,
    category: {
      value: 'TD-TIPs',
      label: ['TD-TIPs'],
    },
    modificationDate: {
      value: '2023-05-08',
      label: ['05/08/2023'],
    },
    id: 'iu-309-d79c2409-5f69-421b-a1e1-aff314b48178',
    objectId: 'esc/iu-309-d79c2409-5f69-421b-a1e1-aff314b48178',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 14279,
    visibilityLevel: {
      level: 1,
      label: 'Internal',
      color: '#FF3E17',
    },
    tags: [],
    additionalFields: [],
    subtitle: [
      'TD-TIPs',
      'Vitocal 250-AH, Vitocal 250-SH, Vitocal 150-A, Vitocal 151-A, Vitocal 250-A, Vitocal 252-A, Vitocal 200-S, Vitocal 222-S',
      '05/08/2023',
    ],
    informationType: {
      value: ['Solution database\u001fTD-TIPs'],
      label: ['TD-TIPs'],
    },
  },
  {
    title: '<hit>Vitocal</hit> 100-A_Suction gas sensor defective E631',
    body:
      '<hit>Vitocal</hit> 100-A_Suction gas sensor defective E631\n\n    \n      Symptom\n\n      \tSuction gas sensor failure with error E631\n\n\n\n    \n    \n      Cause\n\n      \t#\tDescription of causes\n\t#1 ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/02697c98-427e-4f1c-a97d-6c19a535c3bd.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2024-02-02',
      label: ['02/02/2024'],
    },
    id: 'en-so-02697c98-427e-4f1c-a97d-6c19a535c3bd',
    objectId: 'esc/en-so-02697c98-427e-4f1c-a97d-6c19a535c3bd',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 9222,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Error description', '02/02/2024'],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: '<hit>Vitocal</hit> 060/262-A_Corrosion on the evaporator',
    body:
      '<hit>Vitocal</hit> 060/262-A_Corrosion on the evaporator\n\n    \n      Symptom\n\n      Behavior of the installation\n\nSymptom\n\n\tCorrosion occurs on the evaporator (so-called ant nest ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/ecd791e4-9945-4670-84d9-1ce67c58fd99.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2023-09-22',
      label: ['09/22/2023'],
    },
    id: 'en-so-ecd791e4-9945-4670-84d9-1ce67c58fd99',
    objectId: 'esc/en-so-ecd791e4-9945-4670-84d9-1ce67c58fd99',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 10912,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: [
      'Error description',
      'Hot water heat pumps, Vitocal 060-A, Vitocal 262-A',
      '09/22/2023',
    ],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: '<hit>Vitocal</hit> 300-A (Dimplex) brocken refrigerant pipes',
    body:
      '<hit>Vitocal</hit> 300-A (Dimplex) brocken refrigerant pipes\n\n    \n      Symptom\n\n      \tIn the field, ... fitted as standard in <hit>Vitocal</hit> 300-A appliances from 05/2022 ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/2d6f8b18-7e94-4467-939e-c3b4deca2513.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2023-12-05',
      label: ['12/05/2023'],
    },
    id: 'en-so-2d6f8b18-7e94-4467-939e-c3b4deca2513',
    objectId: 'esc/en-so-2d6f8b18-7e94-4467-939e-c3b4deca2513',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 10715,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Error description', 'Heat Pumps, Vitocal 300', '12/05/2023'],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: '<concept>Vitocal</concept> <concept>200-S</concept>',
    body:
      ' ... 7502076, 7502077, 7502078, 7502080,\n7454115,\n\nBezeichnung\nVerwendung\n\n<concept>Vitocal</concept> <concept>200-S</concept>\nInneneinheit, Außeneinheit, <concept>Vitocal</concept> <concept>200-S</concept>,\nKältemittelleitung, Kondensatablauf\n\nBemerkungen:\n\nWeitere Informationen:\n\nAußeneinheit\n\nET / ... ',
    pageCount: 11,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/TD-Doku/drive/C/Empolis/Anbindung%20TD-Doku/TD-Doku_20220630/content/Hilfsmittel/44A076470EEF768CC1257E73002FDF13.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'TD-Doku',
      label: ['TD-Docu'],
    },
    modificationDate: {
      value: '2023-09-14',
      label: ['09/14/2023'],
    },
    id: 'iu-309-57042736-a602-4285-9006-a2324684923d',
    objectId: 'esc/iu-309-57042736-a602-4285-9006-a2324684923d',
    languages: {
      value: ['de'],
      label: ['German'],
    },
    fileSize: 240191,
    visibilityLevel: {
      level: 1,
      label: 'Internal',
      color: '#FF3E17',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Aids', 'Vitocal 200-S', '09/14/2023'],
    informationType: {
      value: ['Solution database\u001fTD-Doku\u001fTD_Doku_009'],
      label: ['Aids'],
    },
  },
  {
    title: '<concept>Vitocal</concept> <concept>200-S</concept> - Pompy ciepła',
    body:
      'VIESMANN\n\nLista kontrolna konserwacji\ndla wykwalifikowanego personelu\n\n<concept>Vitocal</concept> <concept>200-S</concept>\nTyp AWB, AWB 201.B04, AWB 201.B05, AWB 201.B07, ... ',
    pageCount: 2,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/WCL/4753164WCL00002_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2017-01-01',
      label: ['01/01/2017'],
    },
    id: 'iu-309-4b4c009f-ae78-4356-a33f-d18e43e2585a',
    objectId: 'esc/iu-309-4b4c009f-ae78-4356-a33f-d18e43e2585a',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 1016338,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Maintenance checklist', 'Vitocal 200-S', '01/01/2017'],
    informationType: {
      value: ['Checklists\u001fWCL'],
      label: ['Maintenance checklist'],
    },
  },
  {
    title: '<concept>Vitocal</concept> <concept>200-S</concept> - Pompy ciepła',
    body:
      'VIESMANN\n\nLista kontrolna konserwacji\ndla wykwalifikowanego personelu\n\n<concept>Vitocal</concept> <concept>200-S</concept>\nTyp AWB 201.D10, AWB 201.D13, AWB 201.D16, AWB-E-AC ... ',
    pageCount: 2,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/WCL/4753604WCL00001_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2017-07-01',
      label: ['07/01/2017'],
    },
    id: 'iu-309-a1189246-faa0-4d05-aee5-373fcbc7d694',
    objectId: 'esc/iu-309-a1189246-faa0-4d05-aee5-373fcbc7d694',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 1016841,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Maintenance checklist', 'Vitocal 200-S', '07/01/2017'],
    informationType: {
      value: ['Checklists\u001fWCL'],
      label: ['Maintenance checklist'],
    },
  },
  {
    title: '<concept>Vitocal</concept> <concept>200-S</concept> - Pompy ciepła',
    body:
      'VIESMANN\n\nLista kontrolna konserwacji\ndla wykwalifikowanego personelu\n\n<concept>Vitocal</concept> <concept>200-S</concept>\nTyp AWB 201.D10, AWB 201.D13, AWB 201.D16, AWB-E-AC ... ',
    pageCount: 2,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/WCL/4755315WCL00001_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2018-02-01',
      label: ['02/01/2018'],
    },
    id: 'iu-309-84ad140e-fd07-423b-b318-cc4414c63c8f',
    objectId: 'esc/iu-309-84ad140e-fd07-423b-b318-cc4414c63c8f',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 1013421,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Maintenance checklist', 'Vitocal 200-S', '02/01/2018'],
    informationType: {
      value: ['Checklists\u001fWCL'],
      label: ['Maintenance checklist'],
    },
  },
  {
    title: 'do kotła <concept>Vitocal</concept> <concept>200-S</concept>',
    body:
      ' ... dla wykwalifikowanego personelu\n\nPrzepływowy podgrzewacz wody grzewczej\ndo kotła <concept>Vitocal</concept> <concept>200-S</concept>\n\nWskazówki dotyczące bezpieczeństwa\nProsimy o dokładne przestrzeganie wskazówek bezpieczeństwa ... ',
    pageCount: 16,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VMA/5728354VMA00001_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2010-07-01',
      label: ['07/01/2010'],
    },
    id: 'iu-309-de5e6280-520b-40c7-a528-6cef078bf167',
    objectId: 'esc/iu-309-de5e6280-520b-40c7-a528-6cef078bf167',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 3344812,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Technical data manual', 'Vitocal 200, Vitocal 200-G', '07/01/2010'],
    informationType: {
      value: ['Manuals\u001fVMA'],
      label: ['Technical data manual'],
    },
  },
  {
    title:
      '<concept>Vitocal</concept> <concept>200-S</concept> - do kotła <concept>Vitocal</concept> <concept>200-S</concept>',
    body:
      ' ... wykwalifikowanego\n\nModuł sterujący przepływowym podgrzewaczem\nwody grzewczej\ndo kotła <concept>Vitocal</concept> <concept>200-S</concept>\n\nWskazówki bezpieczeństwa\nProsimy o dokładne przestrzeganie wskazówek bezpieczeństwa w ... ',
    pageCount: 8,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VMA/5728345VMA00001_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2010-07-01',
      label: ['07/01/2010'],
    },
    id: 'iu-309-b0fd1496-ee5b-44cb-9011-8fe8725dd6c6',
    objectId: 'esc/iu-309-b0fd1496-ee5b-44cb-9011-8fe8725dd6c6',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 736681,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Technical data manual', 'Vitocal 200-S', '07/01/2010'],
    informationType: {
      value: ['Manuals\u001fVMA'],
      label: ['Technical data manual'],
    },
  },
  {
    title:
      '<concept>Vitocal</concept> <concept>200-S</concept> - do modułu zewnętrznego <concept>Vitocal</concept> <concept>200-S</concept>',
    body:
      ' ... dla wykwalifikowanego personelu\n\nElektryczne ogrzewanie dodatkowe\ndo modułu zewnętrznego <concept>Vitocal</concept> <concept>200-S</concept>\n\nWskazówki bezpieczeństwa\nProsimy o dokładne przestrzeganie wskazówek bezpieczeństwa w ... ',
    pageCount: 12,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VMA/5719649VMA00003_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2024-01-17',
      label: ['01/17/2024'],
    },
    id: 'iu-309-eb565a72-adfb-4761-8ada-4f8ece8187bb',
    objectId: 'esc/iu-309-eb565a72-adfb-4761-8ada-4f8ece8187bb',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 3378230,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Technical data manual', 'Vitocal 200-S', '01/17/2024'],
    informationType: {
      value: ['Manuals\u001fVMA'],
      label: ['Technical data manual'],
    },
  },
  {
    title:
      '<concept>Vitocal</concept> <concept>200-S</concept> - Mont.anl.elektr.Begleitheiz.Kondensw. PL',
    body:
      ' ... ogrzewanie dodatkowe\nDo jednostki zewnętrznej urządzeń <concept>Vitocal</concept> <concept>200-S</concept>/222-S/<hit>242-S</hit> oraz\nVitocaldens <hit>200-F</hit>\n\nWskazówki bezpieczeństwa\nProsimy o dokładne przestrzeganie wskazówek ... ',
    pageCount: 12,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VMA/5719649VMA00004_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2014-02-01',
      label: ['02/01/2014'],
    },
    id: 'iu-309-1c88d9f1-be53-4475-b6d3-ab067bc8e1b8',
    objectId: 'esc/iu-309-1c88d9f1-be53-4475-b6d3-ab067bc8e1b8',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 3436376,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Technical data manual', 'Vitocal 200-S', '02/01/2014'],
    informationType: {
      value: ['Manuals\u001fVMA'],
      label: ['Technical data manual'],
    },
  },
  {
    title: 'E3 One <hit>Base_Vitocal</hit> Function Deep Dive',
    body:
      ' ... 7720674, 7720675\t<concept>Vitocal</concept> <concept>200-S</concept>  IDU\tIDU <concept>Vitocal</concept> <concept>200-S</concept> AWB-E-AC 201. ... <concept>Vitocal</concept> <concept>200-S</concept> AWB-E-AC 201.E10 NEV, \nIDU <concept>Vitocal</concept> <concept>200-S</concept> AWB-E-AC ... ',
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1648212911465/viessmann/confluence/TIP/E3-One-Base_Vitocal-Function-Deep-Dive_80577515_EN.html',
    downloadDenied: false,
    category: {
      value: 'TD-TIPs',
      label: ['TD-TIPs'],
    },
    modificationDate: {
      value: '2023-05-08',
      label: ['05/08/2023'],
    },
    id: 'iu-309-d79c2409-5f69-421b-a1e1-aff314b48178',
    objectId: 'esc/iu-309-d79c2409-5f69-421b-a1e1-aff314b48178',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 14279,
    visibilityLevel: {
      level: 1,
      label: 'Internal',
      color: '#FF3E17',
    },
    tags: [],
    additionalFields: [],
    subtitle: [
      'TD-TIPs',
      'Vitocal 250-AH, Vitocal 250-SH, Vitocal 150-A, Vitocal 151-A, Vitocal 250-A, Vitocal 252-A, Vitocal 200-S, Vitocal 222-S',
      '05/08/2023',
    ],
    informationType: {
      value: ['Solution database\u001fTD-TIPs'],
      label: ['TD-TIPs'],
    },
  },
  {
    title:
      'Regulator pompy ciepła Do <concept>Vitocal</concept> <concept>100-S</concept>, <concept>Vitocal</concept> <concept>200-A</concept> i <concept>Vitocal</concept> <concept>200-S</concept>',
    body:
      ' ... Typ WO1C\nRegulator pompy ciepła\nDo <concept>Vitocal</concept> <concept>100-S</concept>, <concept>Vitocal</concept> <concept>200-A</concept> i <concept>Vitocal</concept> <concept>200-S</concept>\n\nVITOTRONIC 200\n\n5791 939 PL\n\n1/2017 ... ',
    pageCount: 256,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VSA/5791939VSA00001_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2017-01-01',
      label: ['01/01/2017'],
    },
    id: 'iu-309-95121f13-f928-489f-9894-955ba41b458b',
    objectId: 'esc/iu-309-95121f13-f928-489f-9894-955ba41b458b',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 5142189,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: [
      'Service instructions',
      'Vitocal 200-A, Vitocal 100-S, Vitocal 200-S, Vitotronic 200',
      '01/01/2017',
    ],
    informationType: {
      value: ['Manuals\u001fVSA'],
      label: ['Service instructions'],
    },
  },
  {
    title: '<concept>VitoAir</concept> FS_Plastic design cover is sagging',
    body:
      '<concept>VitoAir</concept> FS_Plastic design cover is sagging\n\n    \n      Symptom\n\n      Behavior of the installation\n\nSymptom\n\n\tCover panels are sagging\n\n\n\n\nOfficial version\n\n\tDue to ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/598891b5-4320-4eca-917a-63c967c32ee0.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2023-10-25',
      label: ['10/25/2023'],
    },
    id: 'en-so-598891b5-4320-4eca-917a-63c967c32ee0',
    objectId: 'esc/en-so-598891b5-4320-4eca-917a-63c967c32ee0',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 9277,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Error description', 'Ventilation systems', '10/25/2023'],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: '<concept>VitoAir</concept> FS 300E_F.974 Bypass motor does not work',
    body:
      '<concept>VitoAir</concept> FS 300E_F.974 Bypass motor does not work\n\n    \n      Symptom\n\n      Behavior of the installation\n\nSymptom\n\n\tF.974 is displayed although bypass ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/8fd317c0-5197-4e7c-a5ba-fcc46cb47bb1.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2023-10-09',
      label: ['10/09/2023'],
    },
    id: 'en-so-8fd317c0-5197-4e7c-a5ba-fcc46cb47bb1',
    objectId: 'esc/en-so-8fd317c0-5197-4e7c-a5ba-fcc46cb47bb1',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 10021,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Error description', '10/09/2023'],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: '<concept>VitoAir</concept> FS 300E_Bypass damper does not move to end position',
    body:
      '<concept>VitoAir</concept> FS 300E_Bypass damper does not move to end position ... einer <concept>VitoAir</concept> ~ Exchange VCU for a <concept>VitoAir</concept>\n\n \n\nNeeded spare ... ',
    documentType: {
      value: 'HowTo',
      label: ['Fault description'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/56173883-c94b-412b-aa8b-50d44a49c6cf.eicp/index_en.html',
    downloadDenied: false,
    category: {
      value: 'Service Knowledge',
      label: ['Expert Knowledge'],
    },
    modificationDate: {
      value: '2023-10-05',
      label: ['10/05/2023'],
    },
    id: 'en-so-56173883-c94b-412b-aa8b-50d44a49c6cf',
    objectId: 'esc/en-so-56173883-c94b-412b-aa8b-50d44a49c6cf',
    languages: {
      value: ['en'],
      label: ['English'],
    },
    fileSize: 9648,
    visibilityLevel: {
      level: 0,
      label: '0',
      color: null,
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Error description', 'Ventilation systems', '10/05/2023'],
    informationType: {
      value: ['Solution database\u001fFehlerbeschreibung'],
      label: ['Error description'],
    },
  },
  {
    title: '<concept>Vitoair</concept>, kombinierte Nebenluftvorrichtung, KNL, Zugbegrenzer',
    body:
      ' ... , 7217843, 7300300,7338725,\n7339703\n\nBezeichnung\n\n<concept>Vitoair</concept>, kombinierte Nebenluftvorrichtung, KNL,\nZugbegrenzer\nAbgassystem ... :\n7339703 Komb. Nebenluftvorrichtung-KNL\n7338725 <concept>Vitoair</concept> D=130 + 150\n7217842 ... ',
    pageCount: 4,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/TD-Doku/drive/C/Empolis/Anbindung%20TD-Doku/TD-Doku_20220630/content/Hilfsmittel/13FB0AD48F879438C125772A001CBEAF.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'TD-Doku',
      label: ['TD-Docu'],
    },
    modificationDate: {
      value: '2023-09-14',
      label: ['09/14/2023'],
    },
    id: 'iu-309-a55a9be7-6608-49cc-8f23-4375801658f6',
    objectId: 'esc/iu-309-a55a9be7-6608-49cc-8f23-4375801658f6',
    languages: {
      value: ['de'],
      label: ['German'],
    },
    fileSize: 153261,
    visibilityLevel: {
      level: 1,
      label: 'Internal',
      color: '#FF3E17',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Aids', 'Vitoair', '09/14/2023'],
    informationType: {
      value: ['Solution database\u001fTD-Doku\u001fTD_Doku_009'],
      label: ['Aids'],
    },
  },
  {
    title:
      '<concept>Vitoair</concept> FS - System wentylacji mieszkań z odzyskiem ciepła i wilgoci',
    body:
      ' ... dla użytkownika instalacji grzewczej\nSystem wentylacji mieszkań z odzyskiem ciepła i wilgoci\n\n<concept>VITOAIR</concept> FS\n\n6176294 PL\n\n9/2021\n\nProszę zachować!',
    pageCount: 24,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VBA/6176294VBA00001_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2021-09-01',
      label: ['09/01/2021'],
    },
    id: 'iu-309-294fedb1-36f6-4881-8374-9e406d7dc68c',
    objectId: 'esc/iu-309-294fedb1-36f6-4881-8374-9e406d7dc68c',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 2058795,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Operating instructions', 'Vitoair FS', '09/01/2021'],
    informationType: {
      value: ['Manuals\u001fVBA'],
      label: ['Operating instructions'],
    },
  },
  {
    title:
      '<concept>Vitoair</concept> FS - System wentylacji mieszkań z odzyskiem ciepła i wilgoci',
    body:
      ' ... dla użytkownika instalacji grzewczej\nSystem wentylacji mieszkań z odzyskiem ciepła i wilgoci\n\n<concept>VITOAIR</concept> FS\n\n6176294 PL\n\n1/2022\n\nProszę zachować!',
    pageCount: 24,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VBA/6176294VBA00002_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2022-01-01',
      label: ['01/01/2022'],
    },
    id: 'iu-309-5f2214bd-db56-4706-8bac-0cd606e05437',
    objectId: 'esc/iu-309-5f2214bd-db56-4706-8bac-0cd606e05437',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 2091800,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Operating instructions', 'Vitoair FS', '01/01/2022'],
    informationType: {
      value: ['Manuals\u001fVBA'],
      label: ['Operating instructions'],
    },
  },
  {
    title:
      '<concept>Vitoair</concept> FS - System wentylacji mieszkań z odzyskiem ciepła i wilgoci',
    body:
      ' ... dla użytkownika instalacji grzewczej\nSystem wentylacji mieszkań z odzyskiem ciepła i wilgoci\n\n<concept>VITOAIR</concept> FS\n\n6176294 PL\n\n3/2022\n\nProszę zachować!',
    pageCount: 28,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VBA/6176294VBA00003_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2022-03-01',
      label: ['03/01/2022'],
    },
    id: 'iu-309-3e9814b5-2daf-4c1c-9e9b-104a34cb483d',
    objectId: 'esc/iu-309-3e9814b5-2daf-4c1c-9e9b-104a34cb483d',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 2213073,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Operating instructions', 'Vitoair FS', '03/01/2022'],
    informationType: {
      value: ['Manuals\u001fVBA'],
      label: ['Operating instructions'],
    },
  },
  {
    title:
      'Fehlerbild: <concept>VitoAir</concept> FS 300E Vorheizregister kann nicht in Betrieb genommen',
    body:
      ' ... nicht gestattet\n\nFehlercode/ Fehlerbild:\n\n<concept>VitoAir</concept> FS 300E Vorheizregister kann nicht ... Geräte/ Typ:\n\n<concept>Vitoair</concept> FS 300 E\n\n<concept>Vitoair</concept> FSI 300E bis ... ',
    pageCount: 2,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1643206018781/resources/technical_documents/DE/de/TDT/4482989TDT00001_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents',
      label: ['Technical documents'],
    },
    modificationDate: {
      value: '2023-05-25',
      label: ['05/25/2023'],
    },
    id: 'iu-309-f5cf29bd-91ae-4edd-a3fc-ce441656f182',
    objectId: 'esc/iu-309-f5cf29bd-91ae-4edd-a3fc-ce441656f182',
    languages: {
      value: ['de'],
      label: ['German'],
    },
    fileSize: 409094,
    visibilityLevel: {
      level: 1,
      label: 'Internal',
      color: '#FF3E17',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Support news DE', 'Vitoair FS, Vitoair FSI', '05/25/2023'],
    informationType: {
      value: ['Solution database\u001fTDT'],
      label: ['Support news DE'],
    },
  },
  {
    title:
      '<concept>Vitoair</concept> FS - System wentylacji pomieszczeń mieszkalnych z odzyskiem ciepła i wilgoci',
    body:
      ' ... użytkownika instalacji grzewczej\nSystem wentylacji pomieszczeń mieszkalnych z odzyskiem ciepła i wilgoci\n\n<concept>VITOAIR</concept> FS\n\n6176294 PL\n\n10/2022\n\nProszę zachować!',
    pageCount: 32,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VBA/6176294VBA00004_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2022-10-01',
      label: ['10/01/2022'],
    },
    id: 'iu-309-35b0bdfc-7f77-4573-85d0-ae65bbd55e86',
    objectId: 'esc/iu-309-35b0bdfc-7f77-4573-85d0-ae65bbd55e86',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 2288430,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Operating instructions', 'Vitoair FS', '10/01/2022'],
    informationType: {
      value: ['Manuals\u001fVBA'],
      label: ['Operating instructions'],
    },
  },
  {
    title:
      '<concept>Vitoair</concept> FS - System wentylacji pomieszczeń mieszkalnych z odzyskiem ciepła i wilgoci',
    body:
      ' ... użytkownika instalacji grzewczej\nSystem wentylacji pomieszczeń mieszkalnych z odzyskiem ciepła i wilgoci\n\n<concept>VITOAIR</concept> FS\n\n6191753 PL\n\n2/2023\n\nProszę zachować!',
    pageCount: 28,
    documentType: {
      value: 'Document',
      label: ['Document'],
    },
    downloadLink:
      'resource/environment/project1_p/documents/1698661316432/resources/technical_documents/PL/pl/VBA/6191753VBA00001_1.pdf',
    downloadDenied: false,
    pageNumber: 1,
    category: {
      value: 'Technical documents PL',
      label: ['Technical documents PL'],
    },
    modificationDate: {
      value: '2023-02-01',
      label: ['02/01/2023'],
    },
    id: 'iu-309-67868a46-0316-4b77-aa52-12ce9c629967',
    objectId: 'esc/iu-309-67868a46-0316-4b77-aa52-12ce9c629967',
    languages: {
      value: ['pl'],
      label: ['Polish'],
    },
    fileSize: 1765019,
    visibilityLevel: {
      level: 3,
      label: 'Customer',
      color: '#9D9D9D',
    },
    tags: [],
    additionalFields: [],
    subtitle: ['Operating instructions', 'Vitoair FS', '02/01/2023'],
    informationType: {
      value: ['Manuals\u001fVBA'],
      label: ['Operating instructions'],
    },
  },
];

export const assistantFeedbackMockedData: AssistantFeedback[] = [
  {
    serialNumber: '7725237011111111',
    productName: 'Vitocal',
    errorCode: 'F.333',
    documentId: '123321',
    documentTitle: 'Vitoair bypass pump not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 16 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237011111111',
    productName: 'Vitocal',
    errorCode: 'F.333',
    documentId: '123321',
    documentTitle: 'Vitoair bypass pump not works',
    documentTypes: ['Document'],
    feedbackInput: 'No',
    timestamp: new Date('Apr 15 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237011111111',
    productName: 'Vitocal',
    errorCode: 'F.333',
    documentId: '123321',
    documentTitle: 'Vitoair bypass pump not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 14 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237011111111',
    productName: 'Vitocal',
    errorCode: 'F.333',
    documentId: '123321',
    documentTitle: 'Vitoair bypass pump not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 13 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237011111111',
    productName: 'Vitocal',
    errorCode: 'F.333',
    documentId: '123321',
    documentTitle: 'Vitoair bypass pump not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 12 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237011111111',
    productName: 'Viotcal',
    errorCode: 'F.333',
    documentId: '123321',
    documentTitle: 'Vitoair bypass pump not works',
    documentTypes: ['Document'],
    feedbackInput: 'No',
    timestamp: new Date('Apr 11 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237011111111',
    productName: 'vitocal',
    errorCode: 'F.333',
    documentId: '123321',
    documentTitle: 'Vitoair bypass pump not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 10 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 9 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 8 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'No',
    timestamp: new Date('Apr 7 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 6 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 5 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 4 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'No',
    timestamp: new Date('Apr 3 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 2 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 1 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },

  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 16 2024 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'No',
    timestamp: new Date('Apr 15 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 14 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 13 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 12 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'No',
    timestamp: new Date('Apr 11 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 10 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 9 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 8 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'No',
    timestamp: new Date('Apr 7 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 6 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 5 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 4 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'No',
    timestamp: new Date('Apr 3 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 2 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
  {
    serialNumber: '7725237001281126',
    productName: 'Vitovalor PT2',
    errorCode: 'F.540',
    documentId: '123321',
    documentTitle: 'Vitoair bypass motor not works',
    documentTypes: ['Document'],
    feedbackInput: 'Yes',
    timestamp: new Date('Apr 1 2023 08:01:59 GMT+0200 (Central European Summer Time)'),
    userId: '1234',
    feedbackId: '1234',
  },
];
